import { Radar } from 'src/app/device/shared/interfaces/radar.interface';
import { SchemaRadarInfo } from 'src/app/project/project-schema/shared/interfaces/schema-route-station-info.interface';

/**
 * Übersetzt SchemaRadarInfo in die Radar-Struktur, die der RadarDataChart
 * erwartet. Nur für Einträge mit Daten aufrufen (data != null).
 */
export function mapSchemaRadarToChartRadar(radar: SchemaRadarInfo): Radar {
  const data = radar.data!;
  return {
    kfzTrafficVolume: data.allTrafficVolume,
    lkwTrafficVolume: data.truckTrafficVolume,
    pkwAverageSpeed: data.carAverageSpeed,
    lkwAverageSpeed: data.truckAverageSpeed,
    kfzSmoothedAverageSpeed: data.allSmoothedAverageSpeed,
    kfzStdDeviation: data.allStdDeviation,
    meanNetTimeGap: data.meanNetTimeGap,
    utilization: data.utilization,
    lat: 0,
    lng: 0,
    dateTime: data.dataDateTime,
    de: radar.cInfo.channel.de,
    channelError: radar.cInfo.channel.isInChannelError ?? undefined,
    // Der Chart nutzt radarType nicht; null bleibt zulässig
    radarType: data.radarType!,
    result: {
      triggerType: data.mqResult?.trigger,
      data: data.mqResult?.trafficData,
      z: data.mqResult?.z,
      vs: data.mqResult?.vs,
      line: data.mqResult?.line
    }
  };
}
